import type { CSSProperties, ReactNode } from "react"
import "./styles.css"

export function BigHeading({
  children,
  variant = "h2",
  color,
}: {
  children: ReactNode
  variant?: "h2" | "h3"
  color?: string
}) {
  const Heading = variant
  return (
    <Heading
      className="big-heading"
      data-testid="big-heading"
      style={color ? ({ "--heading-color": color } as CSSProperties) : undefined}
    >
      {children}
    </Heading>
  )
}

export default BigHeading
